module.exports = __webpack_public_path__ + "static/media/IconMinus.c4c8ea68.svg";